import { useMutation, useQueryClient } from "@tanstack/react-query";

import { generateProductionCSID } from "api/device.api";
import {
  invalidateDashboardSources,
  invalidateDeviceSide,
} from "lib/cacheInvalidation";

export const useGenerateProductionCSR = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (deviceId) => generateProductionCSID(deviceId),
    onSuccess: () => {
      invalidateDeviceSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
